import { render } from "./SeSimpleTab.vue?vue&type=template&id=6379ed7d&scoped=true&ts=true"
import script from "./SeSimpleTab.vue?vue&type=script&lang=ts"
export * from "./SeSimpleTab.vue?vue&type=script&lang=ts"

import "./SeSimpleTab.vue?vue&type=style&index=0&id=6379ed7d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6379ed7d"]])

export default __exports__